import React from "react";
import Button from "react-bootstrap/Button";
import { SmallSquareMergeButtonProps } from "./SmallSquareMergeButtonProps";

export default function SmallSquareMergeButton({ isActive = true, ...props }: SmallSquareMergeButtonProps) {
    function getButtonText(): string {
        return `Merge ${props.entityNameSingular}`;
    }

    return (
        <Button
            aria-label={getButtonText()}
            size={"sm"}
            onClick={props.onClick}
            className={props.className}
            variant={props.variant ?? "transparent"}
            disabled={!isActive}
        >
            <i className={"fas fa-people-arrows"} />
        </Button>
    );
}
